module.exports = __webpack_public_path__ + "img/logo_fp.7d020ff7.webp";